Vue.component('ack-product-showcase', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-product-showcase',
	mixins: [languageMixins],
	props: {
		productLocalJsonUrl: {
			type: String,
			default: null,
		},
		panelClass: {
			type: String,
			default: null,
		},
	},
	created() {
		let urlParams = new URLSearchParams(window.location.search);
		let hasParam = urlParams.has('product');
		let product = urlParams.get('product');

		this.PRODUCT = PRODUCT_INFO ? PRODUCT_INFO : null;

		if (!hasParam) {
			if (this.PRODUCT != null) {
				if (this.PRODUCT.vue_product_identifier != null) {
					hasParam = true;
					product = this.PRODUCT.vue_product_identifier;
				}
			}
		}

		if (hasParam) {
			this.setPageIsLoading(true);
			this.showPage = false;

			const fetchProductJSONPromise = this.productLocalJsonUrl
				? this.fetchLocalTranslations({
						productLocalJsonUrl: this.productLocalJsonUrl,
						locale: this.userLanguage,
					})
				: this.fetchTranslations({
						shopCdnUrl: this.shopCdnUrl,
						elementId: 'pr-' + product.toLowerCase(),
						locale: this.userLanguage,
					});

			fetchProductJSONPromise
				.then(() => {
					this.showPage = true;
					this.setPageIsLoading(false);
				})
				.catch((error) => {
					console.error('Failed to fetch translation:', error);
					this.setPageIsLoading(false);
				});

			if (
				(product.toLowerCase() === 'cleani-tank-plus' || product.toLowerCase() === 'uv-box') &&
				(this.countryCode === 'US' || this.countryCode === 'CA')
			) {
				window.location.href = '/';
				return;
			}

			switch (product.toLowerCase()) {
				case 'sol':
					this.productInfo = this.solProductInfo;
					break;
				case 'sol-se':
					this.productInfo = this.solSeProductInfo;
					break;
				case 'dentiq':
					this.productInfo = this.dentiqProductInfo;
					break;
				case 'curie':
					this.productInfo = this.curieProductInfo;
					break;
				case 'curie-plus':
					this.productInfo = this.curiePlusProductInfo;
					break;
				case 'uv-box':
					this.productInfo = this.uvBoxProductInfo;
					break;
				case 'ackuretta-sticker':
					this.productInfo = this.dentiqProductInfo;
					break;
				case 'cleani-dual-tank':
					this.productInfo = this.cleaniDualTankProductInfo;
					break;
				case 'cleani-tank-plus':
					this.productInfo = this.cleaniTankPlusProductInfo;
					break;
				case 'sol-plus':
					this.productInfo = this.solPlusProductInfo;
					break;
				case 'rodin-chroma-flash':
					this.productInfo = this.rodinChromaFlashInfo;
					break;
				default:
					this.productInfo = this.curiePlusProductInfo;
					break;
			}
		} else {
			this.productInfo = this.solPlusProductInfo; // this.dentiqProductInfo //
		}
		//window.addEventListener('scroll', this.handleScroll)
	},
	mounted() {},

	computed: {
		...Vuex.mapGetters('localization', ['userLanguage', 'regions', 'countryCode', 'isIreland']),
		isUSorCA() {
			return this.countryCode === 'US' || this.countryCode === 'CA';
		},
		desLink() {
			return { hyperLink: getExtendedConciergePdf(this.regions) };
		},
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'product-showcase-page',
			mobileMenuOpened: false,
			activeIndex: 0,
			productInfo: null,
			PRODUCT: null,
			solProductInfo: {
				us_3dps_bundle: 'sol-bundle-us-ca',
				default_3dps_bundle: 'shop-3dps-6',
				hasExtendedConciergArea: true,
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'product_showcase.product.sol.title_section.title',
					title_img: window.ackShopifyFileUrl('Logo_Resize-01.png'),
					title_img_us_au: window.ackShopifyFileUrl('SOL_V4_Logo_CS_2_1.png'),
					subtitle: 'product_showcase.product.sol.title_section.subtitle',
					description: 'product_showcase.product.sol.title_section.description',
					image_desktop: window.ackShopifyFileUrl('SOL_V4_Top_banner_1.jpg'),
					image_desktop_us_ca: window.ackShopifyFileUrl('SOL_V4_Top_Banner_CS.png'),
					image_mobile: window.ackShopifyFileUrl(
						'SOL_V4_SOL_de910904-bf69-4988-ac85-ee42fd7cb961.jpg',
					),
					service: 'product_showcase.product.sol.title_section.service',
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.sol.title_section.learn_more',
					add_to_cart: 'product_showcase.product.sol.title_section.add_to_cart',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.sol.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/sol/Global_Digital_SOL_Flyer.pdf',
							link_US_CA: 'https://cdn.ackuretta.com/downloads/sol/US_Digital_SOL_Flyer.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_2.png'),
							title: 'product_showcase.product.sol.collateral_icons.user_guide',
							link_with_concierge: 'https://cdn.ackuretta.com/downloads/sol/CONCIERGE_SOL_QSG.pdf',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_QSG.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_3.png'),
							title: 'product_showcase.product.sol.collateral_icons.compatible_materials',
							link: '/pages/validation-resins',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_8.png'),
							title: 'product_showcase.product.sol.collateral_icons.comparison',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
							onlyIfStoreAvailable: false,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_5.png'),
							title: 'product_showcase.product.sol.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
							onlyIfStoreAvailable: false,
						},
					],
				},
				banner_section: {
					title: 'Less Stress, More Success, We Got You Covered',
					url_image: '/pages/ackuretta-concierge',
					image: window.ackShopifyFileUrl('Concierge_Page_SOL_banner.png'),
					imgAlt: 'Concierge_Page_SOL_banner',
				},
				brands_section: {
					title: 'product_showcase.product.sol.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src: window.ackShopifyFileUrl(
								'SOL_V4_SOL_Plus_f5f32bd3-17be-4caf-8bc3-ab8f84da6890.jpg',
							),
							title: 'product_showcase.product.sol.product_cart_section.product_items.sol.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.sol.description',
							page_url: '/products/sol-se-dental-3d-printer',
							shopifyId: 'gid://shopify/Product/7479252353127',
							variantId: 'gid://shopify/ProductVariant/39309268222055',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CLEANIDualTanks.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.cleani_dual_tank.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.cleani_dual_tank.description',
							page_url: '/products/cleani-washer-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_CURIE_Plus.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.curie_plus.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.curie_plus.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6770993332327',
							variantId: 'gid://shopify/ProductVariant/40137051177063',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('NFinity_2.png'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.nfinity.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.nfinity.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6997757198439',
							variantId: 'gid://shopify/ProductVariant/40744171503719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_S_BP.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.sol_small_bp.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.sol_small_bp.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6630921502823',
							variantId: 'gid://shopify/ProductVariant/39604336754791',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_M_BP.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.sol_medium_bp.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.sol_medium_bp.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6630922485863',
							variantId: 'gid://shopify/ProductVariant/39604337836135',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_L_BP.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.sol_large_bp.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.sol_large_bp.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6590433951847',
							variantId: 'gid://shopify/ProductVariant/39469250543719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.sol.scrolling_section.title',
					scrolling_items: [
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl('SOL_V4_Biocompatible_Dental_Workflows.jpg'),
						},
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl('SOL_V4_Printing.gif'),
						},
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl(
								'SOL_V4_Multiple_3D_Build_Platforms_2ccef58e-5a15-4191-b2ff-55283fe50a80.jpg',
							),
						},
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_four.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_four.description',
							image: window.ackShopifyFileUrl(
								'SOL_V4_Smart_LED_af9a1ea6-704b-4975-8301-42f83cbe8529.jpg',
							),
						},
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_five.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_five.description',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ExtendedCoveragePicture.png?v=1780987303',
						},
					],
				},
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Eugene_Royzengurt.jpg'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Russell_Schafer.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_-Rick_Ferguson.jpg'),
							altText: 'Third slide',
						},
						{
							id: 4,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_four.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_four.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_four.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Hoo_Yin_Shi.jpg'),
							altText: 'Third slide',
						},
						{
							id: 5,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_five.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_five.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_five.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Adam_Nulty.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.sol.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.main_item.title',
							description:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl(
								'SOL_V4_49-micron_Precision_Printing_c962f657-a806-40c0-ac5e-7eadffd2120f.jpg',
							),
						},
						secondary_item: {
							title:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl(
								'SOL_V4_Chair-side_8fa01ed0-a632-4cc6-9511-a8e8c58dc0ea.jpg',
							),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl(
								'SOL_V4_Monochrome_LCD_e0c86607-48cb-4d37-acfd-6e767d6c57b7.jpg',
							),
						},
						tertiary_item_two: {
							title:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl(
								'SOL_V4_Printing_capacity_47c079f7-1498-4b08-9a3a-e54429578b21.jpg',
							),
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				second_media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				image_section: {
					image: window.ackShopifyFileUrl('SOL_Page_Small_Banner_Heater.jpg'),
					notes: 'product_showcase.product.sol.image_section.notes',
				},
			},
			solSeProductInfo: {
				us_3dps_bundle: 'sol-bundle-us-ca',
				default_3dps_bundle: 'shop-3dps-6',
				hasExtendedConciergArea: true,
				title_section: {
					id: 'gid://shopify/Product/7479252353127',
					title: 'product_showcase.product.sol.title_section.title',
					title_img: window.ackShopifyFileUrl('sol_se_logo.png'),
					title_img_us_au: window.ackShopifyFileUrl('sole_se_logo_with_concierge_service.png'),
					subtitle: 'product_showcase.product.sol.title_section.subtitle',
					description: 'product_showcase.product.sol.title_section.description',
					image_desktop: window.ackShopifyFileUrl('sol_se_banner.jpg'),
					image_desktop_us_ca: window.ackShopifyFileUrl('sol_se_concierge_service_banner.jpg'),
					image_mobile: window.ackShopifyFileUrl('sol_se_mobile_banner.png'),
					service: 'product_showcase.product.sol.title_section.service',
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.sol.title_section.learn_more',
					add_to_cart: 'product_showcase.product.sol.title_section.add_to_cart',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.sol.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/sol-se/SOL%20SE_Flyer.pdf',
							link_US_CA: 'https://cdn.ackuretta.com/downloads/sol-se/SOL%20SE_Flyer.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_2.png'),
							title: 'product_showcase.product.sol.collateral_icons.user_guide',
							link: 'https://cdn.ackuretta.com/downloads/sol-se/SOL%20SE_Essential%20User%20Guide_Print.pdf',
							link_US_CA:
								'https://cdn.ackuretta.com/downloads/sol-se/SOL_SE_with_CS_Essential_User_Guide_Print.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_3.png'),
							title: 'product_showcase.product.sol.collateral_icons.compatible_materials',
							link: '/pages/validation-resins',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_8.png'),
							title: 'product_showcase.product.sol.collateral_icons.comparison',
							link: 'https://cdn.ackuretta.com/downloads/sol-se/Ackuretta_Printers_Comparison_1.pdf',
							onlyIfStoreAvailable: false,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_5.png'),
							title: 'product_showcase.product.sol.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
							onlyIfStoreAvailable: false,
						},
						{
							img_src: window.ackShopifyFileUrl(
								'V4_Products_f0ccf888-60d1-414c-8195-9a8d71b5a753.png',
							),
							title: 'product_showcase.product.sol.collateral_icons.legacy_docs',
							link: '/pages/downloads',
							onlyIfStoreAvailable: false,
						},
					],
				},
				banner_section: {
					title: 'Less Stress, More Success, We Got You Covered',
					url_image: '/pages/ackuretta-concierge',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_SOL_SE_banner.jpg?v=1782356338',
					imgAlt: 'Concierge_Page_SOL_banner',
				},
				brands_section: {
					title: 'product_showcase.product.sol.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						// {
						// 	img_src:
						// 		window.ackShopifyFileUrl("SOL_V4_SOL_Plus_f5f32bd3-17be-4caf-8bc3-ab8f84da6890.jpg"),
						// 	title: 'product_showcase.product.sol.product_cart_section.product_items.sol.title',
						// 	description:
						// 		'product_showcase.product.sol.product_cart_section.product_items.sol.description',
						// 	page_url: '/products/sol-se-dental-3d-printer',
						// 	shopifyId: 'gid://shopify/Product/7479252353127',
						// 	variantId: 'gid://shopify/ProductVariant/39309268222055',
						// 	sellingPlanId: null,
						// },
						{
							img_src: '//ackuretta.com/cdn/shop/files/PacDent_Page_Card_Titan.jpg?v=1753090608',
							title:
								'product_showcase.product.sol.product_cart_section.product_items.rodin_titan_resin.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.rodin_titan_resin.description',
							page_url: '/pages/pac-dent',
							shopifyId: 'gid://shopify/Product/6908629811303',
							variantId: 'gid://shopify/ProductVariant/41632175030375',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CLEANIDualTanks.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.cleani_dual_tank.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.cleani_dual_tank.description',
							page_url: '/products/cleani-washer-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_CURIE_Plus.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.curie_plus.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.curie_plus.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6770993332327',
							variantId: 'gid://shopify/ProductVariant/40137051177063',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('NFinity_2.png'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.nfinity.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.nfinity.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6997757198439',
							variantId: 'gid://shopify/ProductVariant/40744171503719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_S_BP.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.sol_small_bp.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.sol_small_bp.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6630921502823',
							variantId: 'gid://shopify/ProductVariant/39604336754791',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_M_BP.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.sol_medium_bp.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.sol_medium_bp.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6630922485863',
							variantId: 'gid://shopify/ProductVariant/39604337836135',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_L_BP.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.sol_large_bp.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.sol_large_bp.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6590433951847',
							variantId: 'gid://shopify/ProductVariant/39469250543719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.sol.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.sol.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.sol.scrolling_section.title',
					scrolling_items: [
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl('SOL_SE_Biocompatible_Dental_Workflows.jpg'),
						},
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl('SOL_SE_Fast_Print_Times.jpg'),
						},
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl(
								'SOL_V4_Multiple_3D_Build_Platforms_2ccef58e-5a15-4191-b2ff-55283fe50a80.jpg',
							),
						},
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_four.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_four.description',
							image: window.ackShopifyFileUrl('SOL_SE_Smart_LED.png'),
						},
						{
							title:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_five.title',
							description:
								'product_showcase.product.sol.scrolling_section.scrolling_items.item_five.description',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ExtendedCoveragePicture.png?v=1780987303',
						},
					],
				},
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Eugene_Royzengurt.jpg'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Russell_Schafer.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_-Rick_Ferguson.jpg'),
							altText: 'Third slide',
						},
						{
							id: 4,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_four.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_four.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_four.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Hoo_Yin_Shi.jpg'),
							altText: 'Third slide',
						},
						{
							id: 5,
							name: 'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_five.name',
							title:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_five.title',
							quote:
								'product_showcase.product.sol.testimonials_section.testimonial_items.testimonial_five.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Adam_Nulty.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.sol.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.main_item.title',
							description:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl(
								'SOL_V4_49-micron_Precision_Printing_c962f657-a806-40c0-ac5e-7eadffd2120f.jpg',
							),
						},
						secondary_item: {
							title:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl(
								'SOL_V4_Chair-side_8fa01ed0-a632-4cc6-9511-a8e8c58dc0ea.jpg',
							),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl(
								'SOL_V4_Monochrome_LCD_e0c86607-48cb-4d37-acfd-6e767d6c57b7.jpg',
							),
						},
						tertiary_item_two: {
							title:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'product_showcase.product.sol.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl('SOL_SE_Printing_capacity.jpg'),
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				second_media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				image_section: {
					image: window.ackShopifyFileUrl('SOL_SE_Heater.jpg'),
					notes: 'product_showcase.product.sol.image_section.notes',
				},
			},
			solPlusProductInfo: {
				default_3dps_bundle: 'shop-3dps-7',
				hasExtendedConciergArea: true,
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'product_showcase.product.sol_plus.title_section.title',
					title_img: window.ackShopifyFileUrl(
						'SOL_Plus_V4_Logo_062ed1bb-a965-4468-8bf3-064f480bff1b.png',
					),
					title_img_us_au: window.ackShopifyFileUrl('SOL_Plus_V4_Logo_CS_2.png'),
					subtitle: 'product_showcase.product.sol_plus.title_section.subtitle',
					description: 'product_showcase.product.sol_plus.title_section.description',
					image_desktop: window.ackShopifyFileUrl(
						'SOL_Plus_V4_Top_Banner_707258a8-9a66-42e9-8c05-22e6764839c1.jpg',
					),
					image_desktop_us_ca: window.ackShopifyFileUrl(
						'SOL_Plus_V4_Banner_CS_6523e806-b449-44ee-82ff-f9935c4f9c7e.png',
					),
					image_mobile: window.ackShopifyFileUrl('V4_SOL_Plus.png'),
					service: 'product_showcase.product.sol_plus.title_section.service',
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.sol_plus.title_section.learn_more',
					add_to_cart: 'product_showcase.product.sol_plus.title_section.add_to_cart',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.sol_plus.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/Global_Digital_SOL%20Plus_Flyer.pdf?v=latest',
							link_US_CA:
								'https://cdn.ackuretta.com/downloads/sol-plus/US_Digital_SOL%20Plus_Flyer.pdf?v=latest',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_2.png'),
							title: 'product_showcase.product.sol_plus.collateral_icons.user_guide',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus_QSG.pdf',
							link_with_concierge:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/sol-plus/SOL+Plus+with+Concierge+Service_QSG.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_3.png'),
							title: 'product_showcase.product.sol_plus.collateral_icons.compatible_materials',
							link: '/pages/validation-resins',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_5.png'),
							title: 'product_showcase.product.sol_plus.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
							onlyIfStoreAvailable: false,
						},
						// sol plus
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_8.png'),
							title: 'product_showcase.product.sol_plus.collateral_icons.comparison',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
							onlyIfStoreAvailable: false,
						},
					],
				},
				banner_section: {
					title: 'Less Stress, More Success, We Got You Covered',
					url_image: '/pages/ackuretta-concierge',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_SOL_Plus_banner.jpg?v=1782356234',
					imgAlt: 'Concierge_Page_SOL_Plus_banner',
				},
				brands_section: {
					title: 'product_showcase.product.sol_plus.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.sol_plus.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.sol_plus.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_2_SOL_Plus.jpg'),
							title:
								'product_showcase.product.sol_plus.product_cart_section.product_items.sol_plus.title',
							description:
								'product_showcase.product.sol_plus.product_cart_section.product_items.sol_plus.description',
							page_url: '/products/sol-plus',
							shopifyId: 'gid://shopify/Product/6857640837223',
							variantId: 'gid://shopify/ProductVariant/40294070157415',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CLEANITankPlus.jpg'),
							title:
								'product_showcase.product.sol_plus.product_cart_section.product_items.cleani_tank_plus.title',
							description:
								'product_showcase.product.sol_plus.product_cart_section.product_items.cleani_tank_plus.description',
							page_url: '/products/cleani-tank-plus',
							shopifyId: 'gid://shopify/Product/6857633071207',
							variantId: 'gid://shopify/ProductVariant/40293990269031',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_CURIE_Plus.jpg'),
							title:
								'product_showcase.product.sol_plus.product_cart_section.product_items.curie_plus.title',
							description:
								'product_showcase.product.sol_plus.product_cart_section.product_items.curie_plus.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6770993332327',
							variantId: 'gid://shopify/ProductVariant/40137051177063',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('NFinity_2.png'),
							title:
								'product_showcase.product.sol_plus.product_cart_section.product_items.nfinity.title',
							description:
								'product_showcase.product.sol_plus.product_cart_section.product_items.nfinity.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6997757198439',
							variantId: 'gid://shopify/ProductVariant/40744171503719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_4_XL_BP.jpg'),
							title:
								'product_showcase.product.sol_plus.product_cart_section.product_items.sol_plus_xl_bp.title',
							description:
								'product_showcase.product.sol_plus.product_cart_section.product_items.sol_plus_xl_bp.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6888831844455',
							variantId: 'gid://shopify/ProductVariant/40402915524711',
							sellingPlanId: null,
						},
						// ],
						// [
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.sol_plus.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.sol_plus.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.sol_plus.scrolling_section.title',
					scrolling_items: [
						{
							title:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl('SOL_Plus_V4_Primary_Features_1_Unmatched.jpg'),
						},
						{
							title:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl('SOL_Plus_V4_Primary_Features_2_High-Capacity.jpg'),
						},
						{
							title:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl(
								'SOL_Plus_V4_Primary_Features_3_Delivers_Reliability.jpg',
							),
						},
						{
							title:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_four.title',
							description:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_four.description',
							image: window.ackShopifyFileUrl('SOL_Plus_V4_Primary_Features_4_Resin_Heater.gif'),
						},
						{
							title:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_five.title',
							description:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_five.description',
							image: window.ackShopifyFileUrl('SOL_Plus_V4_Primary_Features_5_One-Hand_2.gif'),
						},
						{
							title:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_six.title',
							description:
								'product_showcase.product.sol_plus.scrolling_section.scrolling_items.item_six.description',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ExtendedCoveragePicture.png?v=1780987303',
						},
					],
				},
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Eugene_Royzengurt.jpg'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_-Rick_Ferguson.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('Dr._Ahmad_Al-Hassiny.png'),
							altText: 'Third slide',
						},
						{
							id: 4,
							name: 'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_four.name',
							title:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_four.title',
							quote:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_four.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Hoo_Yin_Shi.jpg'),
							altText: 'Third slide',
						},
						{
							id: 5,
							name: 'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_five.name',
							title:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_five.title',
							quote:
								'product_showcase.product.sol_plus.testimonials_section.testimonial_items.testimonial_five.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Adam_Nulty.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.sol_plus.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.sol_plus.media_grid_section.media_grid_collection.main_item.title',
							description:
								'product_showcase.product.sol_plus.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl('SOL_Plus_V4_Secondary_Features_1_Smart_Design.gif'),
						},
						secondary_item: {
							title:
								'product_showcase.product.sol_plus.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'product_showcase.product.sol_plus.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl('SOL_Plus_V4_Secondary_Features_2_Large_Printing.jpg'),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.sol_plus.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'product_showcase.product.sol_plus.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl(
								'SOL_Plus_V4_Secondary_Features_3_Continuous_Updates_a03acf40-4507-4959-9fd6-784596c0e47f.jpg',
							),
						},
						tertiary_item_two: {
							title:
								'product_showcase.product.sol_plus.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'product_showcase.product.sol_plus.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl('SOL_Plus_V4_Secondary_Features_4_Hassle-Free.gif'),
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				second_media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
			},

			dentiqProductInfo: {
				default_3dps_bundle: 'shop-3dps-3',
				hasExtendedConciergArea: false,
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'product_showcase.product.dentiq.title_section.title',
					title_img: window.ackShopifyFileUrl('Logo_Resize-02.png'),
					title_img_us_au: window.ackShopifyFileUrl(
						'DENTIQ_V4_Logo_CS_1_97edcabf-4e58-4d0d-9c31-b8354f84c738.png',
					),
					subtitle: 'product_showcase.product.dentiq.title_section.subtitle',
					description: 'product_showcase.product.dentiq.title_section.description',
					service: 'product_showcase.product.dentiq.title_section.service',
					image_desktop: window.ackShopifyFileUrl('DENTIQ_V4_Top_banner.jpg'),
					image_desktop_us_ca: window.ackShopifyFileUrl('DENTIQ_V4_Top_Banner_CS.png'),
					image_mobile: window.ackShopifyFileUrl('DENTIQ_V4_Mobile.jpg'),
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.dentiq.title_section.learn_more',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.dentiq.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/Global_Digital_DENTIQ%20Flyer.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('DENTIQ_V4_icon_2.png'),
							title: 'product_showcase.product.dentiq.collateral_icons.user_guide',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/DENTIQ_QSG.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('DENTIQ_V4_icon_3.png'),
							title: 'product_showcase.product.dentiq.collateral_icons.compatible_materials',
							link: '/pages/validation-resins',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_8.png'),
							title: 'product_showcase.product.dentiq.collateral_icons.comparison',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
							onlyIfStoreAvailable: false,
						},
						{
							img_src: window.ackShopifyFileUrl('DENTIQ_V4_icon_5.png'),
							title: 'product_showcase.product.dentiq.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
						},
					],
				},
				banner_section: {
					title: 'Less Stress, More Success, We Got You Covered',
					url_image: '/pages/ackuretta-concierge',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_DENTIQ_banner.jpg?v=1782356411',
					imgAlt: 'Concierge_Page_DENTIQ_banner',
				},
				brands_section: {
					title: 'product_showcase.product.dentiq.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'voco',
						'saremco',
						'whipmix',
					],
				},

				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.dentiq.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.dentiq.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_DENTIQ.jpg'),
							title:
								'product_showcase.product.dentiq.product_cart_section.product_items.dentiq.title',
							description:
								'product_showcase.product.dentiq.product_cart_section.product_items.dentiq.description',
							page_url: '/products/dentiq-dental-3d-printer',
							shopifyId: 'gid://shopify/Product/6548762591335',
							variantId: 'gid://shopify/ProductVariant/39304726511719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CLEANIDualTanks.jpg'),
							title:
								'product_showcase.product.dentiq.product_cart_section.product_items.cleani_dual_tank.title',
							description:
								'product_showcase.product.dentiq.product_cart_section.product_items.cleani_dual_tank.description',
							page_url: '/products/cleani-washer-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_CURIE_Plus.jpg'),
							title:
								'product_showcase.product.dentiq.product_cart_section.product_items.curie_plus.title',
							description:
								'product_showcase.product.dentiq.product_cart_section.product_items.curie_plus.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6770993332327',
							variantId: 'gid://shopify/ProductVariant/40137051177063',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('NFinity_2.png'),
							title:
								'product_showcase.product.dentiq.product_cart_section.product_items.nfinity.title',
							description:
								'product_showcase.product.dentiq.product_cart_section.product_items.nfinity.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6997757198439',
							variantId: 'gid://shopify/ProductVariant/40744171503719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('DENTIQ_V4_BP.jpg'),
							title:
								'product_showcase.product.dentiq.product_cart_section.product_items.dentiq_bp.title',
							description:
								'product_showcase.product.dentiq.product_cart_section.product_items.dentiq_bp.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6590433132647',
							variantId: 'gid://shopify/ProductVariant/39469247791207',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.dentiq.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.dentiq.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.dentiq.scrolling_section.title',
					scrolling_items: [
						{
							title:
								'product_showcase.product.dentiq.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.dentiq.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl('DENTIQ_V4_Entry_Level_Solution.gif'),
						},
						{
							title:
								'product_showcase.product.dentiq.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.dentiq.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl(
								'DENTIQ_V4_150_7e3ebdf7-f37c-4ac2-afdc-8fb92fef4775.jpg',
							),
						},
						{
							title:
								'product_showcase.product.dentiq.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.dentiq.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl(
								'DENTIQ_V4_Accuracy_5ed30c66-ab96-4ad8-b900-c945cfa346b1.jpg',
							),
						},
						{
							title:
								'product_showcase.product.dentiq.scrolling_section.scrolling_items.item_four.title',
							description:
								'product_showcase.product.dentiq.scrolling_section.scrolling_items.item_four.description',
							image: window.ackShopifyFileUrl(
								'DENTIQ_V4_Chairside_2dff6852-6318-412c-b889-0dc4d1c3bf4f.jpg',
							),
						},
					],
				},
				testimonials_section: {
					title: 'product_showcase.product.dentiq.testimonials_section.title',
					testimonial_items: [
						//{ id: 1, name: 'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_one.name', title:'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_one.title' , quote: 'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_one.description', img_src: window.ackShopifyFileUrl("0126Testimonials-Dr.-Trang.png"), altText: 'First slide' },
						{
							id: 2,
							name: 'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Satyabodh_Guttal.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Luis_De_Bellis.jpg'),
							altText: 'Third slide',
						},
						{
							id: 4,
							name: 'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_four.name',
							title:
								'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_four.title',
							quote:
								'product_showcase.product.dentiq.testimonials_section.testimonial_items.testimonial_four.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Priyam_Aditya.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.dentiq.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.dentiq.media_grid_section.media_grid_collection.main_item.title',
							description:
								'product_showcase.product.dentiq.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl('DENTIQ_V4_User-centric_design.gif'),
						},
						secondary_item: {
							title:
								'product_showcase.product.dentiq.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'product_showcase.product.dentiq.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl('DENTIQ_V4_dentistry.jpg'),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.dentiq.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'product_showcase.product.dentiq.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl('DENTIQ_V4_Premium_Ownership.gif'),
						},
						tertiary_item_two: {
							title:
								'product_showcase.product.dentiq.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'product_showcase.product.dentiq.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl(
								'DENTIQ_V4_Printing_capacity_053ed0b4-e5e5-4a9f-a502-b408b83612da.jpg',
							),
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				second_media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
			},

			curieProductInfo: {
				default_3dps_bundle: 'shop-3dps-5',
				us_3dps_bundle: 'shop-3dps-curie-us-ca',
				hasExtendedConciergArea: false,
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'product_showcase.product.curie.title_section.title',
					title_img: window.ackShopifyFileUrl('Logo_Resize-04.png'),
					subtitle: 'product_showcase.product.curie.title_section.subtitle',
					description: 'product_showcase.product.curie.title_section.description',
					image_desktop: window.ackShopifyFileUrl(
						'CURIE_V4_Top_Banner_ff1f716c-34d2-4c40-8920-5fb2363e3669.jpg',
					),
					image_mobile: window.ackShopifyFileUrl('CURIE_V4_Mobile.jpg'),
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.curie.title_section.learn_more',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.curie.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/curie/Global_Digital_CURIE_Flyer.pdf',
							link_US_CA:
								'https://cdn.ackuretta.com/downloads/curie/Global_Digital_CURIE_Flyer.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('CURIE_V4_icon_2.png'),
							title: 'product_showcase.product.curie.collateral_icons.quick_start_guide',
							link: 'https://cdn.ackuretta.com/downloads/curie/CURIE%2024_11_2022.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('CURIE_V4_Feature_Icons_5.png'),
							title: 'product_showcase.product.curie.collateral_icons.resin_library',
							link: window.ackShopifyFileUrl('CURIE_Resin_Profile_Library_Update_Guide.pdf'),
						},
						{
							img_src: window.ackShopifyFileUrl('CURIE_V4_icon_3.png'),
							title: 'product_showcase.product.curie.collateral_icons.compatible_resins',
							link: '/pages/validation-resins',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_8.png'),
							title: 'product_showcase.product.curie.collateral_icons.comparison',
							link: 'https://go.ackuretta.com/comparison-uv-ovens/downloads',
						},
						{
							img_src: window.ackShopifyFileUrl('CURIE_V4_icon_5.png'),
							title: 'product_showcase.product.curie.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
							onlyIfStoreAvailable: false,
						},
					],
				},
				banner_section: {
					title: 'Less Stress, More Success, We Got You Covered',
					url_image: '/pages/ackuretta-concierge',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_CURIE_banner.jpg?v=1782356811',
					imgAlt: 'Concierge_Page_CURIE_banner',
				},
				brands_section: {
					title: 'product_showcase.product.dentiq.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'voco',
						'saremco',
						'whipmix',
					],
				},

				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.curie.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.curie.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src: window.ackShopifyFileUrl('sol_se_product.png'),
							title: 'product_showcase.product.curie.product_cart_section.product_items.sol.title',
							description:
								'product_showcase.product.curie.product_cart_section.product_items.sol.description',
							page_url: '/products/sol-se-dental-3d-printer',
							shopifyId: 'gid://shopify/Product/7479252353127',
							variantId: 'gid://shopify/ProductVariant/39309268222055',
							sellingPlanId: null,
							onlyIfStoreAvailable: true,
						},
						// sol with concierge for us and ca
						{
							img_src: window.ackShopifyFileUrl('Store_page_SOL_SE_with_Concierge_Service.jpg'),
							title:
								'product_showcase.product.curie.product_cart_section.product_items.sol_concierge.title',
							description:
								'product_showcase.product.curie.product_cart_section.product_items.sol_concierge.description',
							page_url: '/products/sol-se-dental-3d-printer',
							shopifyId: 'gid://shopify/Product/7479392796775',
							variantId: 'gid://shopify/ProductVariant/42036022640743',
							sellingPlanId: null,
							onlyifUSorCA: true,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CLEANIDualTanks.jpg'),
							title:
								'product_showcase.product.curie.product_cart_section.product_items.cleani_dual_tank.title',
							description:
								'product_showcase.product.curie.product_cart_section.product_items.cleani_dual_tank.description',
							page_url: '/products/cleani-washer-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CURIE.jpg'),
							title:
								'product_showcase.product.curie.product_cart_section.product_items.curie.title',
							description:
								'product_showcase.product.curie.product_cart_section.product_items.curie.description',
							page_url: '/products/sol-se-dental-3d-printer',
							shopifyId: 'gid://shopify/Product/6555508670567',
							variantId: 'gid://shopify/ProductVariant/39332849090663',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.curie.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.curie.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
							onlyIfStoreAvailable: true,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.curie.scrolling_section.title',
					scrolling_items: [
						{
							title:
								'product_showcase.product.curie.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.curie.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl(
								'CURIE_V4_Improved_Versatility_ce3c214b-7505-4ddd-b72a-9f5e088b7482.jpg',
							),
						},
						{
							title:
								'product_showcase.product.curie.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.curie.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl(
								'CURIE_V4_360_UV_Light_Distribution_5a35971c-19d4-4f83-a8e2-5f135c67af9e.jpg',
							),
						},
						{
							title:
								'product_showcase.product.curie.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.curie.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl(
								'CURIE_V4_Suitable_For_Bio-Resins_68e117aa-78d6-4ae9-9c49-76816ffc6e76.jpg',
							),
						},
					],
				},
				testimonials_section: {
					title: 'product_showcase.product.curie.testimonials_section.title',
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('0126Testimonials-Dr.-Trang.png'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Fermin_Ocanas.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.curie.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Luis_De_Bellis.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.curie.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.curie.media_grid_section.media_grid_collection.main_item.title',
							description:
								'product_showcase.product.curie.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl('CURIE_V4_Perfect_Chamber_Space_gif.jpg'),
						},
						secondary_item: {
							title:
								'product_showcase.product.curie.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'product_showcase.product.curie.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl('CURIE_V4_Compact_Efficient_SOL_SE.jpg'),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.curie.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'product_showcase.product.curie.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl('CURIE_V4_Convenient_SD_Card_Reader__Future-proof.gif'),
						},
						tertiary_item_two: {
							title:
								'product_showcase.product.curie.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'product_showcase.product.curie.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl('CURIE_V4_Heat_Management_System.gif'),
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				second_media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
			},
			rodinChromaFlashInfo: {
				hasExtendedConciergArea: false,
				title_section: {
					id: 'gid://shopify/Product/7506165923943',
					title: 'product_showcase.product.rodin_chroma_flash.title_section.title',
					title_img: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Logo.png'),
					subtitle: 'product_showcase.product.rodin_chroma_flash.title_section.subtitle',
					description: 'product_showcase.product.rodin_chroma_flash.title_section.description',
					image_desktop: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Top_Banner.png'),
					image_mobile: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Mobile_Top.png'),
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.rodin_chroma_flash.title_section.learn_more',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.rodin_chroma_flash.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/rodin-chroma-flash/Rodin_Chroma_Flash_Flyer.pdf?v=latest',
							link_US_CA:
								'https://cdn.ackuretta.com/downloads/rodin-chroma-flash/Rodin_Chroma_Flash_Flyer.pdf?v=latest',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_2.png'),
							title: 'product_showcase.product.rodin_chroma_flash.collateral_icons.user_guide',
							link: 'https://cdn.ackuretta.com/downloads/rodin-chroma-flash/Rodin_Chroma_Flash_QSG.pdf?v=latest',
						},
					],
				},
				brands_section: {
					title: 'product_showcase.product.dentiq.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				products_cart_section: {
					product_items: [],
				},
				scrolling_section: {
					title: 'product_showcase.product.rodin_chroma_flash.scrolling_section.title',
					description: ' ',
					scrolling_items: [
						{
							title:
								'product_showcase.product.rodin_chroma_flash.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.rodin_chroma_flash.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl('Rodin_Chroma_Flash_High_Mechanical.jpg'),
						},
						{
							title:
								'product_showcase.product.rodin_chroma_flash.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.rodin_chroma_flash.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Color_Stability.jpg'),
						},
						{
							title:
								'product_showcase.product.rodin_chroma_flash.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.rodin_chroma_flash.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Open_Compatibility.jpg'),
						},
						{
							title:
								'product_showcase.product.rodin_chroma_flash.scrolling_section.scrolling_items.item_four.title',
							description:
								'product_showcase.product.rodin_chroma_flash.scrolling_section.scrolling_items.item_four.description',
							image: window.ackShopifyFileUrl('Efficient_Workflow.gif'),
						},
					],
				},
				testimonials_section: {
					title: 'product_showcase.product.rodin_chroma_flash.testimonials_section.title',
					is_display: false,
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Miguel_De_Leon.jpg'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Susan_McMahon.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.rodin_chroma_flash.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Eugene_Royzengurt.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.rodin_chroma_flash.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.rodin_chroma_flash.media_grid_section.media_grid_collection.main_item.description',
							description: '',
							img: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Best-in-Class_Technology_1.jpg'),
							panel_class: {
								col: '',
								media_card: 'flex-fill',
							},
						},
						secondary_item: {
							title:
								'product_showcase.product.rodin_chroma_flash.media_grid_section.media_grid_collection.secondary_item.description',
							description: '',
							img: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Best-in-Class_Technology_2.jpg'),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.rodin_chroma_flash.media_grid_section.media_grid_collection.tertiary_item_one.description',
							description: '',
							img: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Best-in-Class_Technology_3.jpg'),
							panel_class: {
								col: 'flex-fill',
								media_card: '',
							},
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},

				comparison_media_grid_section: {
					title: '',
					media_grid_items: [],
				},
				image_section: {
					title: 'product_showcase.product.rodin_chroma_flash.image_section.title',
					image: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Why_Rodin_Chroma_Flash.png'),
				},
				second_image_section: {
					title: 'product_showcase.product.rodin_chroma_flash.second_image_section.title',
					image: window.ackShopifyFileUrl('Rodin_Chroma_Flash_Technical_Specifications.png'),
					// url_image: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_SOP.pdf?v=latest',
				},
				third_image_section: {
					title: 'product_showcase.product.rodin_chroma_flash.third_image_section.title',
					image: window.ackShopifyFileUrl(
						'Rodin_Chroma_Flash_Your__Complete_3D_Printing_Ecosystem.png',
					),
				},
				fourth_image_section: {
					title: 'product_showcase.product.rodin_chroma_flash.fourth_image_section.title',
					image: window.ackShopifyFileUrl('Rodin_Chroma_Flash_8_min.png'),
				},
				video_section: {
					title: '',
					subtitle: null,
					description: '',
					video: '',
				},
			},
			curiePlusProductInfo: {
				default_3dps_bundle: 'shop-3dps-6',
				us_3dps_bundle: 'shop-3dps-curie-plus-us-ca',
				hasExtendedConciergArea: false,
				// bundle_title: 'Get my UV Curing Station',
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'product_showcase.product.curie_plus.title_section.title',
					title_img: window.ackShopifyFileUrl('Logo_Resize-05.png'),
					title_image_text: 'product_showcase.product.curie_plus.title_section.title_image_text',
					subtitle: 'product_showcase.product.curie_plus.title_section.subtitle',
					description: 'product_showcase.product.curie_plus.title_section.description',
					image_desktop: window.ackShopifyFileUrl('Website-V4.0-CURIE_Plus_Top_Banner.jpg'),
					image_mobile: window.ackShopifyFileUrl('Navigation_Bar_Products_CURIE_Plus_NFinity.png'),
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.curie_plus.title_section.learn_more',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.curie_plus.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/Web_CURIE%20Plus%20Flyer.pdf?v=latest',
							link_US_CA:
								'https://cdn.ackuretta.com/downloads/curie-plus/Web_CURIE%20Plus%20Flyer.pdf?v=latest',
						},
						{
							img_src: window.ackShopifyFileUrl('CURIE_Plus_V4_icon_QSG_Curie_Plus.png'),
							title: 'product_showcase.product.curie_plus.collateral_icons.user_guide_curie_plus',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_QSG.pdf?v=latest',
						},
						{
							img_src: window.ackShopifyFileUrl('CURIE_Plus_V4_icon_QSG_NFinity.png'),
							title: 'product_showcase.product.curie_plus.collateral_icons.user_guide_nfinity',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/Nfinity_QSG.pdf?v=latest',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_3.png'),
							title: 'product_showcase.product.curie_plus.collateral_icons.compatible_materials',
							link: '/pages/validation-resins',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_8.png'),
							title: 'product_showcase.product.curie_plus.collateral_icons.comparison',
							link: 'https://go.ackuretta.com/comparison-uv-ovens/downloads',
						},
						// {
						// 	img_src:
						// 		window.ackShopifyFileUrl("CURIE_Plus_V4_icon_4.png"),
						// 	title:
						// 		'product_showcase.product.curie_plus.collateral_icons.technical_specifications',
						// 	link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_Technical%20Specifications%20Sheet.pdf?v=latest',
						// },
						{
							img_src: window.ackShopifyFileUrl('CURIE_Plus_V4_icon_5.png'),
							title: 'product_showcase.product.curie_plus.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
							onlyIfStoreAvailable: false,
						},
					],
				},
				banner_section: {
					title: 'Less Stress, More Success, We Got You Covered',
					url_image: '/pages/ackuretta-concierge',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_CURIE_Plus_banner.jpg?v=1782356691',
					imgAlt: 'Concierge_Page_CURIE_Plus_banner',
				},
				brands_section: {
					title: 'product_showcase.product.dentiq.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.curie_plus.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.curie_plus.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_2_SOL_Plus.jpg'),
							title:
								'product_showcase.product.curie_plus.product_cart_section.product_items.sol_plus.title',
							description:
								'product_showcase.product.curie_plus.product_cart_section.product_items.sol_plus.description',
							page_url: '/products/sol-plus-high-volume-dental-3d-printer',
							shopifyId: 'gid://shopify/Product/6857640837223',
							variantId: 'gid://shopify/ProductVariant/40294070157415',
							sellingPlanId: null,
							onlyIfStoreAvailable: true,
						},
						// sol plus with concierge for us and ca
						{
							img_src: window.ackShopifyFileUrl('Store_page_SOL_Plus_with_Concierge_Service.jpg'),
							title:
								'product_showcase.product.curie_plus.product_cart_section.product_items.sol_plus_concierge.title',
							description:
								'product_showcase.product.curie_plus.product_cart_section.product_items.sol_plus_concierge.description',
							page_url: '/products/sol-plus-high-volume-dental-3d-printer',
							shopifyId: 'gid://shopify/Product/7096869191783',
							variantId: 'gid://shopify/ProductVariant/40965894996071',
							sellingPlanId: null,
							onlyifUSorCA: true,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CLEANIDualTanks.jpg'),
							title:
								'product_showcase.product.curie_plus.product_cart_section.product_items.cleani_dual_tank.title',
							description:
								'product_showcase.product.curie_plus.product_cart_section.product_items.cleani_dual_tank.description',
							page_url: '/products/cleani-washer-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_CURIE_Plus.jpg'),
							title:
								'product_showcase.product.curie_plus.product_cart_section.product_items.curie_plus.title',
							description:
								'product_showcase.product.curie_plus.product_cart_section.product_items.curie_plus.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6770993332327',
							variantId: 'gid://shopify/ProductVariant/40137051177063',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('NFinity_2.png'),
							title:
								'product_showcase.product.curie_plus.product_cart_section.product_items.nfinity.title',
							description:
								'product_showcase.product.curie_plus.product_cart_section.product_items.nfinity.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6997757198439',
							variantId: 'gid://shopify/ProductVariant/40744171503719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('CURIE_Plus_V4_N2_Cover.png'),
							title:
								'product_showcase.product.curie_plus.product_cart_section.product_items.n2_cover_kit.title',
							description:
								'product_showcase.product.curie_plus.product_cart_section.product_items.n2_cover_kit.description',
							page_url: '#',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.curie_plus.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.curie_plus.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
							onlyIfStoreAvailable: true,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.curie_plus.scrolling_section.title',
					description: 'product_showcase.product.curie_plus.scrolling_section.description',
					scrolling_items: [
						{
							title:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl(
								'Biocompatible_Dental_Workflows_9540370a-8000-4332-b065-1ee7a3b916c3.gif',
							),
						},
						{
							title:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl('Full_capacity.gif'),
						},
						{
							title:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl(
								'CURIE_Plus_NFinity_V5_SOL_SE_Seamless_Integration.jpg',
							),
						},
						{
							title:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_four.title',
							description:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_four.description',
							image: window.ackShopifyFileUrl(
								'CURIE_Plus_NFinity_V5_Instant_Library_Updates_Ease_of_Use.jpg',
							),
						},
						{
							title:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_five.title',
							description:
								'product_showcase.product.curie_plus.scrolling_section.scrolling_items.item_five.description',
							image: window.ackShopifyFileUrl('No_Flipping_Required.gif'),
						},
					],
				},
				testimonials_section: {
					title: 'product_showcase.product.curie_plus.testimonials_section.title',
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Miguel_De_Leon.jpg'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Susan_McMahon.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.curie_plus.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Eugene_Royzengurt.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				comparison_media_grid_section: {
					title: 'product_showcase.product.curie_plus.comparison_media_grid_section.title',
					media_grid_items: [
						{
							type: 'slider',
							beforeImage: window.ackShopifyFileUrl(
								'Without-NFinity_61e6fc11-d8c9-4db9-a687-bf218af6c0cc.jpg',
							),
							beforeCaption:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_one.without_nitrogen',
							afterImage: window.ackShopifyFileUrl(
								'With-NFinity_b49e3431-ffca-4d0c-903f-07ec2f82cd16.jpg',
							),
							afterCaption:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_one.with_nitrogen',
							heading:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_one.title',
							description:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_one.description',
							notes: 'product_showcase.product.curie_plus.image_section.notes',
						},
						{
							type: 'card',
							heading:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_two.title',
							description:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_two.description',
							backgroundImage: window.ackShopifyFileUrl(
								'CURIE_Plus_NFinity_V5_Secondary_Features_2_Safe_Reliable.jpg',
							),
						},
						{
							type: 'card',
							heading:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_three.title',
							description:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_three.description',
							backgroundImage: window.ackShopifyFileUrl(
								'CURIE_Plus_NFinity_V5_Secondary_Features_3_Space-Efficiency_at_its_Best.png',
							),
						},
						{
							type: 'card',
							heading:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_four.title',
							description:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_four.description',
							backgroundImage: window.ackShopifyFileUrl(
								'CURIE_Plus_NFinity_V5_Nitrogen_Purity.png',
							),
						},
						{
							type: 'card',
							heading:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_five.title',
							description:
								'product_showcase.product.curie_plus.comparison_media_grid_section.media_grid_collection.item_five.description',
							backgroundImage: window.ackShopifyFileUrl(
								'CURIE_Plus_NFinity_V5_Unlimited_Nitrogen.jpg',
							),
						},
					],
				},
				image_section: {
					image: window.ackShopifyFileUrl('CURIE_Plus_NFinity_V5_Nitrogen_Curing_Banner.png'),
				},
				second_image_section: {
					image: window.ackShopifyFileUrl(
						'CURIE_Plus_NFinity_V5_Nitrogen_Tank_CURIE_Plus_Setup.png',
					),
					url_image: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_SOP.pdf?v=latest',
				},
				video_section: {
					title: 'product_showcase.product.curie_plus.video_section.title',
					subtitle: null,
					description: 'product_showcase.product.curie_plus.video_section.description',
					video: 'https://www.youtube.com/embed/s586SBgVYcI?si=LQp7HFy7N2LVH1nN',
				},
			},

			uvBoxProductInfo: {
				default_3dps_bundle: 'shop-3dps-1',
				hasExtendedConciergArea: false,
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'product_showcase.product.uv_box.title_section.title',
					title_img: window.ackShopifyFileUrl('Logo_Resize-06.png'),
					subtitle: 'product_showcase.product.uv_box.title_section.subtitle',
					description: 'product_showcase.product.uv_box.title_section.description',
					image_desktop: window.ackShopifyFileUrl('UVBox_V4_Top_Banner_jpg.png'),
					image_mobile: window.ackShopifyFileUrl('UV_Box_V4_Mobile.jpg'),
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.uv_box.title_section.learn_more',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('DENTIQ_V4_icon_1.png'),
							title: 'product_showcase.product.uv_box.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/uv-box/Global_Digital_UV%20Box_Flyer.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_2.png'),
							title: 'product_showcase.product.uv_box.collateral_icons.quick_start_guide',
							link: 'https://drive.google.com/file/d/1o0teDacq2v2Bct-Iq0qKQVo17un28xMU/view',
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_icon_8.png'),
							title: 'product_showcase.product.uv_box.collateral_icons.comparison',
							link: 'https://go.ackuretta.com/comparison-uv-ovens/downloads',
						},
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_4.png'),
							title: 'product_showcase.product.uv_box.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
						},
					],
				},

				brands_section: {
					title: 'product_showcase.product.dentiq.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',

						'voco',
						'saremco',
						'whipmix',
					],
				},
				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.uv_box.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.uv_box.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_DENTIQ.jpg'),
							title:
								'product_showcase.product.uv_box.product_cart_section.product_items.dentiq.title',
							description:
								'product_showcase.product.uv_box.product_cart_section.product_items.dentiq.description',
							page_url: '/products/dentiq-dental-3d-printer',
							shopifyId: 'gid://shopify/Product/6548762591335',
							variantId: 'gid://shopify/ProductVariant/39304726511719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CLEANIDualTanks.jpg'),
							title:
								'product_showcase.product.uv_box.product_cart_section.product_items.cleani_dual_tank.title',
							description:
								'product_showcase.product.uv_box.product_cart_section.product_items.cleani_dual_tank.description',
							page_url: '/products/cleani-washer-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_UVBOX.jpg'),
							title:
								'product_showcase.product.uv_box.product_cart_section.product_items.uv_box.title',
							description:
								'product_showcase.product.uv_box.product_cart_section.product_items.uv_box.description',
							page_url: '/pages/showcase?product=uv-box',
							shopifyId: 'gid://shopify/Product/6571819466855',
							variantId: 'gid://shopify/ProductVariant/39396453613671',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.uv_box.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.uv_box.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.uv_box.scrolling_section.title',
					scrolling_items: [
						{
							title:
								'product_showcase.product.uv_box.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.uv_box.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl('UVBox_V4_Even_Curing_Mirror_Reflection.jpg'),
						},
						{
							title:
								'product_showcase.product.uv_box.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.uv_box.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl('UVBox_V4_Mix_Matrix_LED_Spectrum.jpg'),
						},
						{
							title:
								'product_showcase.product.uv_box.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.uv_box.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl('UVBox_V4_Suitable_for_Model_Production.jpg'),
						},
						{
							title:
								'product_showcase.product.uv_box.scrolling_section.scrolling_items.item_four.title',
							description:
								'product_showcase.product.uv_box.scrolling_section.scrolling_items.item_four.description',
							image: window.ackShopifyFileUrl(
								'UVBox_V4_Light_Flashing_614f2f2b-099d-4c61-a10d-b2692e6cfb85.gif',
							),
						},
					],
				},
				testimonials_section: {
					title: 'product_showcase.product.uv_box.testimonials_section.title',
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('0126Testimonials-Dr.-Trang.png'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Luis_De_Bellis.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.uv_box.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Hoo_Yin_Shi.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.uv_box.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.uv_box.media_grid_section.media_grid_collection.main_item.title',
							description:
								'product_showcase.product.uv_box.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl('UVBox_V4_Instant_Ease_at_Your_Fingertips.gif'),
						},
						secondary_item: {
							title:
								'product_showcase.product.uv_box.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'product_showcase.product.uv_box.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl('UVBox_V4_Perfect_Chamber_Space.jpg'),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.uv_box.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'product_showcase.product.uv_box.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl('UVBox_V4_Small_Size_and_Carbon_Footprint.jpg'),
						},
						tertiary_item_two: {
							title:
								'product_showcase.product.uv_box.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'product_showcase.product.uv_box.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl('UVBox_V4_The_Perfect_Entry_Level_UV_Oven.jpg'),
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				second_media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
			},
			cleaniTankPlusProductInfo: {
				default_3dps_bundle: 'shop-3dps-8',
				hasExtendedConciergArea: false,
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'product_showcase.product.cleani_tank_plus.title_section.title',
					title_img: window.ackShopifyFileUrl('CLEANI_Tank_Plus_V4_Logo_with_CLEANI_Vertical.png'),
					subtitle: 'product_showcase.product.cleani_tank_plus.title_section.subtitle',
					description: 'product_showcase.product.cleani_tank_plus.title_section.description',
					image_desktop: window.ackShopifyFileUrl('CLEANI_Tank_Plus_V4_Top_Banner.jpg'),
					image_mobile: window.ackShopifyFileUrl('V4_Tank_Plus.png'),
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.cleani_tank_plus.title_section.learn_more',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.cleani_tank_plus.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/cleani-tank-plus/CLEANI%20with%20Tank%20Plus_Flyer_Digital.pdf',
							link_US_CA:
								'https://cdn.ackuretta.com/downloads/cleani-tank-plus/CLEANI%20with%20Tank%20Plus_Flyer_Digital.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_2.png'),
							title: 'product_showcase.product.cleani_tank_plus.collateral_icons.user_guide',
							link: 'https://cdn.ackuretta.com/downloads/cleani-tank-plus/CLEANI%20with%20Tank%20Plus_QSG.pdf?v=latest',
						},
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_4.png'),
							title:
								'product_showcase.product.cleani_tank_plus.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
							onlyIfStoreAvailable: true,
						},
					],
				},
				banner_section: {
					title: 'Less Stress, More Success, We Got You Covered',
					url_image: '/pages/ackuretta-concierge',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_CLEANI_Tank_Plus_banner.jpg?v=1782356909',
					imgAlt: 'Concierge_Page_Cleani_with_Tank_Plus',
				},
				brands_section: {
					title: 'product_showcase.product.dentiq.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',

						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',

						'voco',
						'saremco',
						'whipmix',
					],
				},

				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src: window.ackShopifyFileUrl(
								'SOL_V4_SOL_Plus_f5f32bd3-17be-4caf-8bc3-ab8f84da6890.jpg',
							),
							title:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.sol_plus.title',
							description:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.sol_plus.description',
							page_url: '/products/sol-plus',
							shopifyId: 'gid://shopify/Product/6857640837223',
							variantId: 'gid://shopify/ProductVariant/40294070157415',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('V4_Tank_Plus.png'),
							title:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.cleani_tank_plus.title',
							description:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.cleani_tank_plus.description',
							page_url: '/products/cleani-tank-plus',
							shopifyId: 'gid://shopify/Product/6857633071207',
							variantId: 'gid://shopify/ProductVariant/40293990269031',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_CURIE_Plus.jpg'),
							title:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.curie_plus.title',
							description:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.curie_plus.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6770993332327',
							variantId: 'gid://shopify/ProductVariant/40137051177063',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('NFinity_2.png'),
							title:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.nfinity.title',
							description:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.nfinity.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6997757198439',
							variantId: 'gid://shopify/ProductVariant/40744171503719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.cleani_tank_plus.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.cleani_tank_plus.scrolling_section.title',
					scrolling_items: [
						{
							title:
								'product_showcase.product.cleani_tank_plus.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.cleani_tank_plus.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl(
								'CLEANI_Tank_Plus_V4_Primary_Features_1_Made_to_Match_9e737bff-46da-4a8b-adc0-ac5d19bd5726.jpg',
							),
						},
						{
							title:
								'product_showcase.product.cleani_tank_plus.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.cleani_tank_plus.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl(
								'CLEANI_Tank_Plus_V4_Primary_Features_2_High-Volume_bb3d2f21-63a2-4f96-9860-afd5d0f3b65f.jpg',
							),
						},
						{
							title:
								'product_showcase.product.cleani_tank_plus.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.cleani_tank_plus.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl(
								'CLEANI_Tank_Plus_V4_Primary_Features_3_Wash_Cycle_aea4a97c-399a-41d9-a079-445281b98497.gif',
							),
						},
					],
				},
				testimonials_section: {
					title: 'product_showcase.product.cleani_tank_plus.testimonials_section.title',
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Fermin_Ocanas.jpg'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Susan_McMahon.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.cleani_tank_plus.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Miguel_De_Leon.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.cleani_tank_plus.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.cleani_tank_plus.media_grid_section.media_grid_collection.main_item.title',
							description:
								'product_showcase.product.cleani_tank_plus.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl(
								'CLEANI_Tank_Plus_V4_Shared_Features_1_Say_Goodbye_1.gif',
							),
						},
						secondary_item: {
							title:
								'product_showcase.product.cleani_tank_plus.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'product_showcase.product.cleani_tank_plus.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl('CLEANI_Tank_Plus_V4_Shared_Features_2_Preset.gif'),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.cleani_tank_plus.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'product_showcase.product.cleani_tank_plus.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl(
								'CLEANI_Tank_Plus_V4_Shared_Features_3_No_guesswork-_Hydrometer_for_Clean_Alcohol_in_the_Tank_43176cad-7e0e-4b8a-8c51-e577a5f2c417.jpg',
							),
						},
						tertiary_item_two: {
							title:
								'product_showcase.product.cleani_tank_plus.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'product_showcase.product.cleani_tank_plus.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl(
								'CLEANI_Tank_Plus_V4_Shared_Features_4_Perfectly_Sized_for_Dental_Practices.jpg',
							),
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				second_media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
			},
			cleaniDualTankProductInfo: {
				default_3dps_bundle: 'shop-3dps-6',
				us_3dps_bundle: 'shop-3dps-curie-plus-us-ca',
				hasExtendedConciergArea: false,
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'product_showcase.product.cleani_dual_tank.title_section.title',
					title_img: window.ackShopifyFileUrl('CLEANI_Dual_Tank_V4_Logo_with_CLEANI_Vertical.png'),
					subtitle: 'product_showcase.product.cleani_dual_tank.title_section.subtitle',
					description: 'product_showcase.product.cleani_dual_tank.title_section.description',
					image_desktop: window.ackShopifyFileUrl('CLEANI_Dual_Tank_V4_Top_Banner.jpg'),
					image_mobile: window.ackShopifyFileUrl('V4_Dual_Tanks.png'),
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'product_showcase.product.cleani_dual_tank.title_section.learn_more',
				},
				icons_section: {
					collateral_items: [
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_1.png'),
							title: 'product_showcase.product.cleani_dual_tank.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/cleani/Global_Digital_CLEANI_Flyer.pdf?v=latest',
							link_US_CA: 'https://cdn.ackuretta.com/downloads/cleani/US_Digital_CLEANIs_Flyer.pdf',
						},
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_2.png'),
							title: 'product_showcase.product.cleani_dual_tank.collateral_icons.user_guide',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI%20with%20Dual%20Tanks_QSG.pdf?v=latest',
						},
						{
							img_src: window.ackShopifyFileUrl('UVBox_V4_icon_4.png'),
							title:
								'product_showcase.product.cleani_dual_tank.collateral_icons.shipping_restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
							onlyIfStoreAvailable: true,
						},
					],
				},
				banner_section: {
					title: 'Less Stress, More Success, We Got You Covered',
					url_image: '/pages/ackuretta-concierge',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_CLEANI_Dual_Tanks_banner.jpg?v=1782356960',
					imgAlt: 'Concierge_Page_CLEANI_with_Dual_Tanks',
				},
				brands_section: {
					title: 'product_showcase.product.dentiq.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',

						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',

						'voco',
						'saremco',
						'whipmix',
					],
				},

				products_cart_section: {
					product_items: [
						{
							img_src: window.ackShopifyFileUrl('SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg'),
							title:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.alpha_ai.title',
							description:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.alpha_ai.description',
							page_url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src: window.ackShopifyFileUrl(
								'SOL_V4_SOL_Plus_f5f32bd3-17be-4caf-8bc3-ab8f84da6890.jpg',
							),
							title:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.sol_plus.title',
							description:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.sol_plus.description',
							page_url: '/products/sol-plus',
							shopifyId: 'gid://shopify/Product/6857640837223',
							variantId: 'gid://shopify/ProductVariant/40294070157415',
							sellingPlanId: null,
							onlyIfStoreAvailable: true,
						},
						// sol plus with concierge for us and canada
						{
							img_src: window.ackShopifyFileUrl('Store_page_SOL_Plus_with_Concierge_Service.jpg'),
							title:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.sol_plus_concierge.title',
							description:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.sol_plus_concierge.description',
							page_url: '/products/sol-plus',
							shopifyId: 'gid://shopify/Product/7096869191783',
							variantId: 'gid://shopify/ProductVariant/40965894996071',
							sellingPlanId: null,
							onlyifUSorCA: true,
						},
						{
							img_src: window.ackShopifyFileUrl('Storepage_CLEANIDualTanks.jpg'),
							title:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.cleani_dual_tank.title',
							description:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.cleani_dual_tank.description',
							page_url: '/products/cleani-washer-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_CURIE_Plus.jpg'),
							title:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.curie_plus.title',
							description:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.curie_plus.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6770993332327',
							variantId: 'gid://shopify/ProductVariant/40137051177063',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('NFinity_2.png'),
							title:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.nfinity.title',
							description:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.nfinity.description',
							page_url: '/products/curie-plus',
							shopifyId: 'gid://shopify/Product/6997757198439',
							variantId: 'gid://shopify/ProductVariant/40744171503719',
							sellingPlanId: null,
						},
						{
							img_src: window.ackShopifyFileUrl('SOL_V4_Ackuretta_Concierge.jpg'),
							title:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'product_showcase.product.cleani_dual_tank.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: '/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
							onlyIfStoreAvailable: true,
						},
					],
				},
				scrolling_section: {
					title: 'product_showcase.product.cleani_dual_tank.scrolling_section.title',
					scrolling_items: [
						{
							title:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_one.title',
							description:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_one.description',
							image: window.ackShopifyFileUrl(
								'CLEANI_Dual_Tank_V4_Primary_Features_1_Biocompatible_Workflows.jpg',
							),
						},
						{
							title:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_two.title',
							description:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_two.description',
							image: window.ackShopifyFileUrl('CLEANI_Dual_Tank_V4_2-in-1.jpg'),
						},
						{
							title:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_three.title',
							description:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_three.description',
							image: window.ackShopifyFileUrl(
								'CLEANI_Dual_Tank_V4_Primary_Features_3_6_Minutes_2_Cycles_jpg.gif',
							),
						},
						{
							title:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_four.title',
							description:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_four.description',
							image: window.ackShopifyFileUrl(
								'CLEANI_Dual_Tank_V4_Primary_Features_4_4_Full_Arches_Capacity.jpg',
							),
						},
						{
							title:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_five.title',
							description:
								'product_showcase.product.cleani_dual_tank.scrolling_section.scrolling_items.item_five.description',
							image: window.ackShopifyFileUrl(
								'CLEANI_Dual_Tank_V4_Primary_Features_5_Alcohol_Consumption.jpg',
							),
						},
					],
				},
				testimonials_section: {
					title: 'product_showcase.product.cleani_dual_tank.testimonials_section.title',
					testimonial_items: [
						{
							id: 1,
							name: 'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_one.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Fermin_Ocanas.jpg'),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_two.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Susan_McMahon.jpg'),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'product_showcase.product.cleani_dual_tank.testimonials_section.testimonial_items.testimonial_three.description',
							img_src: window.ackShopifyFileUrl('KOL_Testimonials_Miguel_De_Leon.jpg'),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'product_showcase.product.cleani_dual_tank.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title:
								'product_showcase.product.cleani_dual_tank.media_grid_section.media_grid_collection.main_item.title',
							description:
								'product_showcase.product.cleani_dual_tank.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl(
								'CLEANI_Dual_Tank_V4_Shared_Features_1_Say_goodbye.gif',
							),
						},
						secondary_item: {
							title:
								'product_showcase.product.cleani_dual_tank.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'product_showcase.product.cleani_dual_tank.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl('CLEANI_Dual_Tank_V4_Shared_Features_2_Preset.gif'),
						},
						tertiary_item_one: {
							title:
								'product_showcase.product.cleani_dual_tank.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'product_showcase.product.cleani_dual_tank.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl(
								'CLEANI_Dual_Tank_V4_Shared_Features_3_No_guesswork_f1b3d8d3-7198-46bc-aff6-46328e2ea8e9.jpg',
							),
						},
						tertiary_item_two: {
							title:
								'product_showcase.product.cleani_dual_tank.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'product_showcase.product.cleani_dual_tank.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl(
								'CLEANI_Dual_Tank_V4_Shared_Features_4_Perfectly_Sized.jpg',
							),
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
				second_media_grid_section: {
					title: null,
					media_grid_collection: {
						main_item: {
							title: null,
							description: null,
							img: null,
						},
						secondary_item: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_one: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_two: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_three: {
							title: null,
							description: null,
							img: null,
						},
						tertiary_item_four: {
							title: null,
							description: null,
							img: null,
						},
					},
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions('localization', ['fetchTranslations', 'fetchLocalTranslations']),
		...Vuex.mapActions(['setPageIsLoading']),
		setActiveAvatar(index) {
			// Rotate the testimonials array to make the clicked avatar centered
			const length = this.testimonials.length;
			const mid = Math.floor(length / 2);
			let toMove = (index + length - mid) % length;

			for (let i = 0; i < toMove; i++) {
				this.testimonials.push(this.testimonials.shift());
			}

			// Update the active index
			this.activeIndex = mid;
		},
	},

	beforeDestroy() {
		//window.removeEventListener('scroll', this.handleScroll)
	},
	watch: {
		slides: {
			handler() {},
			deep: false,
		},
	},
});
